'use strict';

/* globals RELATIVE_PATH */

require([RELATIVE_PATH + '/plugins/nodebb-plugin-lessons/static/vendor/vue.js'], function (Vue) {
	Vue.component('image-answer-view', {
		props: ['answer'],
		template: 
		'<div style="height: 350px; display: flex; justify-content: center; align-items: center;">' +
			'<img :src="answer.content" alt="" style="max-height: 100%; max-width: 100%;" />' +
		'</div>',
	});
});
